import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { Skeleton, Timeline } from 'antd';
import messageIcon2 from '@Images/icons/icon-message.png';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import './style.scss';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import ActivityLogActions from '@Actions/activityLogActions';

const HistoryLog = ({
  title, id, entity_name, entity_id, getHistoryActivityLog, activityLogHistoryComments, getHistoryActivityLogLoading,
}) => {
  useEffect(() => {
    getHistoryActivityLog({ entity_name, entity_id, id });
  }, []);

  return getHistoryActivityLogLoading
    ? (
      <div
        className="HistoryLog-list-wrapper"
      >
        <h3>{title}</h3>
        {

          [1, 2, 3, 4]?.map((item) => (
            <div
              key={item}
              className="HistoryLog__card"
            >
              <div className="HistoryLog-card-spacing">

                <div className="HistoryLog-card-header ">

                  <div className="loadingBlock loading-HistoryLog-header__text" />
                  <div className="loadingBlock loading-HistoryLog-header__image"> </div>
                </div>

                <div className="loadingBlock loading-HistoryLog-card__link"> </div>
                <div className="HistoryLog-card-footer">
                  <div
                    className="flex "
                  >
                    <p className="loadingBlock loading-HistoryLog-card__footer" />
                  </div>
                </div>
              </div>
            </div>

          ))

        }

      </div>

    ) : (
      <React.Fragment>
        <h3>{title}</h3>
        <br />
        <Timeline>

          {activityLogHistoryComments?.data?.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))?.map((item) => (
            <Timeline.Item
              key={item?.log_id}
            >
              <div
                className="history-log__item "
              >
                <H3Image
                  src={messageIcon2}
                  className="history-log__item-comment-icon"

                />
                <H3Text
                  className="history-log__item-comment "
                  text={(
                    <React.Fragment>
                      <span
                        className=" history-log__item-message-subtext"
                      >
                        {item?.message}

                      </span>
                      <H3Text
                        text={item?.edited ? `edited by ${item?.modified_by_info?.first_name} on ${dayjs(item?.timestamp).format('MMM DD, YYYY hh:mm A')}` : `${item?.modified_by_info?.first_name} on ${dayjs(item?.timestamp).format('MMM DD, YYYY hh:mm A')}`}
                        className="activity-log__item-user"
                      />
                    </React.Fragment>
                  )}
                />
              </div>
            </Timeline.Item>
          ))}

        </Timeline>
      </React.Fragment>

    );
};

const mapStateToProps = ({ UserReducers, ActivityLogReducers }) => ({
  user: UserReducers.user,
  editActivityLogLoading: ActivityLogReducers.editActivityLogLoading,
  getHistoryActivityLogLoading: ActivityLogReducers.getHistoryActivityLogLoading,
  activityLogHistoryComments: ActivityLogReducers.activityLogHistoryComments,

});

const mapDispatchToProps = (dispatch) => ({
  getHistoryActivityLog: (payload, callback) => dispatch(ActivityLogActions.getHistoryActivityLog(payload, callback)),
  getHistoryActivityLogSuccess: (payload) => dispatch(ActivityLogActions.getHistoryActivityLogSuccess(payload)),

});

HistoryLog.propTypes = {
  title: PropTypes.any,
  id: PropTypes.any,
  entity_name: PropTypes.any,
  entity_id: PropTypes.any,
  getHistoryActivityLog: PropTypes.any,
  data: PropTypes.any,
  activityLogHistoryComments: PropTypes.any,
  getHistoryActivityLogLoading: PropTypes.any,

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(HistoryLog));
